export const APP_LOOKUP_IDS = {
  CaseBehaviorTypes: 146,
  OperationalDefinition: 147,
  Frequency: 148,
  Intensity: 149,
  Environmnets: 150,
  SettingEvents: 151,
  Antecedents: 152,
  Consequences: 153,
  Goals: 154,
};
